import { __decorate } from "tslib";
import { singleton } from 'tsyringe';
var EventCallbacksPair = /** @class */ (function () {
    function EventCallbacksPair(eventType, callback) {
        this.eventType = eventType;
        this.callbacks = [callback];
    }
    return EventCallbacksPair;
}());
var BasketEventBus = /** @class */ (function () {
    function BasketEventBus() {
        this.eventCallbacksPairs = [];
    }
    BasketEventBus.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (Array.isArray(eventType)) {
            eventType.forEach(function (x) { _this.subscribe(x, callback); });
        }
        else {
            var eventCallbacksPair = this.findEventCallbacksPair(eventType);
            if (eventCallbacksPair) {
                eventCallbacksPair.callbacks.push(callback);
            }
            else {
                this.eventCallbacksPairs.push(new EventCallbacksPair(eventType, callback));
            }
        }
    };
    BasketEventBus.prototype.unsubscribe = function (eventType, callback) {
        var _this = this;
        if (Array.isArray(eventType)) {
            eventType.forEach(function (x) { return _this.unsubscribe(x, callback); });
        }
        else {
            var eventCallbacksPair = this.findEventCallbacksPair(eventType);
            var callbackIndex = eventCallbacksPair.callbacks.indexOf(callback);
            if (callbackIndex === -1) {
                console.warn("Unable to unsubscribe ".concat(callback, " from '").concat(eventType, "' event."));
                return;
            }
            eventCallbacksPair.callbacks.splice(callbackIndex, 1);
        }
    };
    BasketEventBus.prototype.post = function (eventType) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var eventCallbacksPair = this.findEventCallbacksPair(eventType);
        if (!eventCallbacksPair) {
            console.warn("no subscribers for event ".concat(eventType));
            return;
        }
        eventCallbacksPair.callbacks.forEach(function (callback) { return callback.apply(null, args); });
    };
    BasketEventBus.prototype.findEventCallbacksPair = function (eventType) {
        return this.eventCallbacksPairs
            .filter(function (eventObject) { return eventObject.eventType === eventType; })[0];
    };
    BasketEventBus = __decorate([
        singleton()
    ], BasketEventBus);
    return BasketEventBus;
}());
export { BasketEventBus };
